import { sqConstants } from '../../_constants';
import { sqServices } from '../../_services';
// import { history } from '../../_helpers';
import { alertActions, confirmPromptActions, notificationActions, userActions } from '../index';

export const sqActions = {
    //end
    getListOfSqForAe,
    getListOfSqForSm,
    getListOfSqForAud,
    getListOfSqForFA,
    getListOfArchieveSq,
    CreateSQWTerms,
    UpdateSqWTerms,
    deleteSqWTerms,
    getSqWTerms,
    getTermsByCargoType,
    updateSQStatus,
    addToArchive,
    generateCharges,

    sqClear,
    clearCharges,

    searchCustSQViewer,
    readGroupSQ,

    sqReportsBooking,

    SqUpdates,

    getSqWTermsAmendedSqref,

    getListOfSqForSBM,

    getPresData,

    getOpenVan,

    deactivateSQ,

    // SQ Memorandum
    getListSQCharges,
    getCompanyPolicy,
    getListSQforMemo,
    proceedtoSQMemo,

    // Aging
    searchAe,
    searchCustomerperAe,
    agingReportAe,

    downloadAllSQperCustomer,

    sqExpiration,
    getListSQforExpiration,
    SQDeactivation,
    SQDeactivationLog,
};

function sqClear() { return { type: sqConstants.CLEAR_SQ } }

function clearCharges() { return { type: sqConstants.CLEAR_CHARGES } }

function sqFetching() { return { type: sqConstants.SQ_FETCHING } }
function sqFetched() { return { type: sqConstants.SQ_FETCHED } }

function sqSubmitting() { return { type: sqConstants.SQ_SUBMITTING } }
function sqSubmitted() { return { type: sqConstants.SQ_SUBMITTED } }

function termsGenerating() { return { type: sqConstants.SQ_TERMS_GENERATING } }
function termsGenerated() { return { type: sqConstants.SQ_TERMS_GENERATED } }

function chargesGenerating() { return { type: sqConstants.SQ_CHARGES_GENERATING } }
function chargesGenerated() { return { type: sqConstants.SQ_CHARGES_GENERATED } }

function sqExpiration(payload, ref) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        sqServices.sqExpiration(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Sales Quotation changed successfully'));
                    dispatch(sqActions.getSqWTerms(ref));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function getListSQforExpiration(payload, ref) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.getListSQforExpiration(payload)
            .then(
                sqDeactive => {
                    if (sqDeactive.length > 0) {
                        dispatch(success(sqDeactive));
                    } else {
                        dispatch(alertActions.warning("No SQ Found!"))
                    }
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqDeactive) { return { type: sqConstants.SQ_DEACTIVATE, sqDeactive } }
}

function SQDeactivation(payload) {
    return dispatch => {
        dispatch(sqSubmitting());
        dispatch(userActions.notallowLeavePage());
        sqServices.SQDeactivation(payload)
            .then(
                SQDeactivated => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(success(SQDeactivated));
                    dispatch(sqSubmitted());
                    dispatch(alertActions.success('Sales Quotation ' + SQDeactivated.message));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(sqSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(SQDeactivated) { return { type: sqConstants.SQ_DEACTIVATED, SQDeactivated } }
}

function SQDeactivationLog(payload, ref) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.SQDeactivationLog(payload)
            .then(
                sqDeactiveLog => {
                    if (sqDeactiveLog.length > 0) {
                        dispatch(success(sqDeactiveLog));
                    } else {
                        dispatch(alertActions.warning("No Log Found!"))
                    }
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqDeactiveLog) { return { type: sqConstants.SQ_DEACTIVATE_LOG, sqDeactiveLog } }
}

function downloadAllSQperCustomer(payload) {
    return dispatch => {
        dispatch(sqFetching());
        sqServices.downloadAllSQperCustomer(payload)
            .then(
                AllSQperCustomer => {
                    dispatch(success(AllSQperCustomer));
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(AllSQperCustomer) { return { type: sqConstants.ALL_SQ_PER_CUSTOMER, AllSQperCustomer } }
}

function getCompanyPolicy() {
    return dispatch => {
        dispatch(sqFetching());
        sqServices.getCompanyPolicy()
            .then(
                sqListCompanyPolicy => {
                    dispatch(success(sqListCompanyPolicy));
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqListCompanyPolicy) { return { type: sqConstants.SQ_LIST_COMPANY_POLICY, sqListCompanyPolicy } }
}
function getListSQCharges() {
    return dispatch => {
        dispatch(sqFetching());
        sqServices.getListSQCharges()
            .then(
                sqListCharge => {
                    dispatch(success(sqListCharge));
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqListCharge) { return { type: sqConstants.SQ_LIST_CHARGE, sqListCharge } }
}
function getListSQforMemo(payload) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.getListSQforMemo(payload)
            .then(
                sqMemo => {
                    dispatch(success(sqMemo));
                    if (sqMemo.length > 0) {
                        dispatch(success(sqMemo));
                    } else {
                        dispatch(alertActions.warning("No SQ Found!"))
                    }
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqMemo) { return { type: sqConstants.SQ_MEMORANDUM, sqMemo } }
}
function proceedtoSQMemo(payload) {
    return dispatch => {
        dispatch(sqSubmitting());
        dispatch(userActions.notallowLeavePage());
        sqServices.proceedtoSQMemo(payload)
            .then(
                SQProceedMemo => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(success(SQProceedMemo));
                    dispatch(sqSubmitted());
                    dispatch(alertActions.success('Sales Quotation ' + SQProceedMemo.message));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(sqSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(SQProceedMemo) { return { type: sqConstants.SQ_PROCEED_MEMO, SQProceedMemo } }
}

function getOpenVan(payload) {
    return dispatch => {
        dispatch(sqFetching());
        sqServices.getOpenVan(payload)
            .then(
                SQOpenVan => {
                    dispatch(success(SQOpenVan));
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(SQOpenVan) { return { type: sqConstants.SQ_OPEN_VAN, SQOpenVan } }
}

function getListOfSqForAe(UserId, DocumentStatus, skip, take, filter, search) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.getListOfSqForAe(UserId, DocumentStatus, skip, take, filter, search)
            .then(
                salesQuotations => {
                    if (salesQuotations.length > 0) {
                        dispatch(success(salesQuotations));
                        dispatch(sqFetched());
                    } else {
                        dispatch(alertActions.warning(salesQuotations.message))
                        dispatch(sqFetched());
                    }
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(salesQuotations) { return { type: sqConstants.LIST_OF_SQ, salesQuotations } }
}
function getListOfSqForSm(userBranch, UserId, DocumentStatus, skip, take, filter, search) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.getListOfSqForSm(userBranch, UserId, DocumentStatus, skip, take, filter, search)
            .then(
                salesQuotations => {
                    if (salesQuotations.length > 0) {
                        dispatch(success(salesQuotations));
                        dispatch(sqFetched());
                    } else {
                        dispatch(alertActions.warning(salesQuotations.message))
                        dispatch(sqFetched());
                    }
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(salesQuotations) { return { type: sqConstants.LIST_OF_SQ, salesQuotations } }
}
function getListOfSqForSBM(userBranch, UserId, DocumentStatus, skip, take, filter, search) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.getListOfSqForSBM(userBranch, UserId, DocumentStatus, skip, take, filter, search)
            .then(
                salesQuotations => {
                    if (salesQuotations.length > 0) {
                        dispatch(success(salesQuotations));
                        dispatch(sqFetched());
                    } else {
                        dispatch(alertActions.warning(salesQuotations.message))
                        dispatch(sqFetched());
                    }
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(salesQuotations) { return { type: sqConstants.LIST_OF_SQ, salesQuotations } }
}
function getListOfSqForAud(UserId, DocumentStatus, skip, take, filter, search) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.getListOfSqForAud(UserId, DocumentStatus, skip, take, filter, search)
            .then(
                salesQuotations => {
                    if (salesQuotations.length > 0) {
                        dispatch(success(salesQuotations));
                        dispatch(sqFetched());
                    } else {
                        dispatch(alertActions.warning(salesQuotations.message))
                        dispatch(sqFetched());
                    }
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(salesQuotations) { return { type: sqConstants.LIST_OF_SQ, salesQuotations } }
}
function getListOfSqForFA(UserId, DocumentStatus, skip, take, filter, search) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.getListOfSqForFA(UserId, DocumentStatus, skip, take, filter, search)
            .then(
                salesQuotations => {
                    if (salesQuotations.length > 0) {
                        dispatch(success(salesQuotations));
                        dispatch(sqFetched());
                    } else {
                        dispatch(alertActions.warning(salesQuotations.message))
                        dispatch(sqFetched());
                    }
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(salesQuotations) { return { type: sqConstants.LIST_OF_SQ, salesQuotations } }
}
function getListOfArchieveSq(UserId, skip, take, filter, search) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.getListOfArchieveSq(UserId, skip, take, filter, search)
            .then(
                salesQuotationsArchive => {
                    if (salesQuotationsArchive.length > 0) {
                        dispatch(success(salesQuotationsArchive));
                        dispatch(sqFetched());
                    } else {
                        dispatch(alertActions.warning(salesQuotationsArchive.message))
                        dispatch(sqFetched());
                    }
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(salesQuotationsArchive) { return { type: sqConstants.LIST_OF_SQ_AE_ARCHIVE, salesQuotationsArchive } }
}
function CreateSQWTerms(payload) {
    return dispatch => {
        dispatch(sqSubmitting());
        dispatch(userActions.notallowLeavePage());
        sqServices.CreateSQWTerms(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(sqSubmitted());
                    dispatch(alertActions.success('Sales quotation added successfully'));
                    window.location.href = '/sales_quotation/draft/read/' + success.sqRefNum;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(sqSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function UpdateSqWTerms(payload, SQRefNum) {
    return dispatch => {
        dispatch(sqSubmitting());
        dispatch(userActions.notallowLeavePage());
        sqServices.UpdateSqWTerms(payload, SQRefNum)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(sqSubmitted());
                    dispatch(alertActions.success('Sales quotation updated successfully'));
                    window.location.href = '/sales_quotation/draft/read/' + SQRefNum;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    // console.log(error)
                    dispatch(sqSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteSqWTerms(UserId, DocumentStatus, skip, take, id, type, ) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        sqServices.deleteSqWTerms(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Sales quotation draft deleted successfully'));
                    if (type === "specific") {
                        window.location.href = '/sales_quotation/draft';
                    }
                    else dispatch(getListOfSqForAe(UserId, DocumentStatus, 0, take));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    if (type === "specific") dispatch(getSqWTerms(id));
                    else dispatch(getListOfSqForAe(UserId, DocumentStatus, 0, take));
                }
            );
    };
}
function getSqWTerms(SQRefNum) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.getSqWTerms(SQRefNum)
            .then(
                salesQuotation => {
                    dispatch(sqFetched());
                    dispatch(success(salesQuotation))
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(salesQuotation) { return { type: sqConstants.GET_SQ_BY_REFNUM, salesQuotation } }
}
function getSqWTermsAmendedSqref(SQRefNum) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.getSqWTermsAmendedSqref(SQRefNum)
            .then(
                SQAmended => {
                    dispatch(sqFetched());
                    dispatch(success(SQAmended))
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(SQAmended) { return { type: sqConstants.GET_SQ_WITH_AMEND, SQAmended } }
}
function getTermsByCargoType(code, sqdate) {
    return dispatch => {
        dispatch(termsGenerating())
        sqServices.getTermsByCargoType(code, sqdate)
            .then(
                termsAndConditions => {
                    dispatch(termsGenerated())
                    dispatch(success(termsAndConditions));
                },
                error => {
                    dispatch(termsGenerated());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(termsAndConditions) { return { type: sqConstants.GET_TERMS_BY_CARGO_TYPE, termsAndConditions } }
}
function updateSQStatus(newUrl, status, payload, ref, rowVersion, notification) {
    return dispatch => {
        let stat;
        if (status === 'For Approval') stat = 'Sales quotation was submitted successfully!';
        else if (status === 'SM Approved' || status === 'FA Approved') stat = 'Sales quotation was approved successfully!';
        else if (status === 'SM Denied' || status === 'AUD Denied' || status === 'FA Denied') stat = 'Sales quotation was denied successfully!';
        else if (status === 'Cancelled') stat = 'Sales quotation was cancelled successfully!';
        else if (status === 'Draft') stat = 'Sales quotation was successfully move to draft!';
        else if (status === 'AUD Approved') stat = 'Sales quotation was forwarded successfully!';
        dispatch(userActions.notallowLeavePage());
        sqServices.updateSQStatus(payload, ref, rowVersion)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    if (notification) {
                        dispatch(notificationActions.CreateSQNotification(notification));
                        if(notification.roleId === 'FA'){
                            let DATA = {
                                userId: notification.userId
                            }
                            dispatch(getPresData(DATA))
                        }
                    }
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success(stat))
                    setTimeout(() => {
                        window.location.href = newUrl;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    if (status === 'For Approval') dispatch(getSqWTerms(ref));
                }
            );
    };
}
function addToArchive(DateInput, UserId) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        sqServices.addToArchive(DateInput, UserId)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Sales quotation archived!'))
                    window.location.href = '/sales_quotation/archive';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function generateCharges(payload) {
    return dispatch => {
        dispatch(chargesGenerating())
        sqServices.generateCharges(payload)
            .then(
                charges => {
                    dispatch(chargesGenerated())
                    dispatch(success(charges));
                },
                error => {
                    dispatch(chargesGenerated())
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(charges) { return { type: sqConstants.SQ_CHARGES, charges } }
}
function searchCustSQViewer(customer) {
    return dispatch => {
        dispatch(sqFetching());
        sqServices.searchCustSQViewer(customer)
            .then(
                sqViewer => {
                    dispatch(success(sqViewer));
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqViewer) { return { type: sqConstants.SQ_VIEWER, sqViewer } }
}
function readGroupSQ(data, skip, take, search) {
    return dispatch => {
        dispatch(sqFetching());
        dispatch(userActions.allowLeavePage());
        sqServices.readGroupSQ(data, skip, take, search)
            .then(
                sqCustomerGroupViewer => {
                    if (sqCustomerGroupViewer.length > 0) {
                        dispatch(success(sqCustomerGroupViewer));
                        dispatch(sqFetched());
                    } else {
                        dispatch(alertActions.warning(sqCustomerGroupViewer.message))
                        dispatch(sqFetched());
                    }
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqCustomerGroupViewer) { return { type: sqConstants.SQ_CUSTOMER_GROUP, sqCustomerGroupViewer } }
}
function sqReportsBooking(data) {
    return dispatch => {
        dispatch(sqFetching());
        sqServices.sqReportsBooking(data)
            .then(
                sqReportBooking => {
                    if (sqReportBooking.length > 0) {
                        dispatch(success(sqReportBooking));
                        dispatch(sqFetched());
                    } else {
                        dispatch(alertActions.warning('No Data'))
                        dispatch(sqFetched());
                    }
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqReportBooking) { return { type: sqConstants.SQ_REPORTS_BOOKING, sqReportBooking } }
}
function SqUpdates(data, link) {
    return dispatch => {
        // dispatch(sqFetching());
        dispatch(userActions.notallowLeavePage());
        sqServices.SqUpdates(data)
            .then(
                sqUpdateData => {
                    dispatch(userActions.allowLeavePage());
                    // console.log('sqUpdateData', sqUpdateData)
                    dispatch(success(sqUpdateData));
                    dispatch(confirmPromptActions.hide());
                    // dispatch(sqFetched());
                    if (sqUpdateData.message) { dispatch(alertActions.success(sqUpdateData.message)) }
                    setTimeout(() => {
                        if(link){ window.location.href = link;}
                        if(data.updateType === 'DELETEDOCUMENT' || data.updateType === 'DELETESQ'){ window.location.reload() }                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    // dispatch(sqFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqUpdateData) { return { type: sqConstants.SQ_UPDATE, sqUpdateData } }
}

function getPresData(data) {
    return dispatch => {
        dispatch(sqFetching());
        sqServices.getPresData(data)
            .then(
                sqPresData => {
                    dispatch(success(sqPresData))
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(sqPresData) { return { type: sqConstants.SQ_PRES_DATA, sqPresData } }
}

function deactivateSQ(payload, backlocation) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        sqServices.deactivateSQ(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Sales quotation deactivated!'))
                    setTimeout(() => {
                        window.location.href = backlocation;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

// Aging
function searchAe(payload) {
    return dispatch => {
        dispatch(sqFetching());
        sqServices.searchAe(payload)
            .then(
                aeUser => {
                    dispatch(success(aeUser));
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(aeUser) { return { type: sqConstants.SQ_AGING_AE, aeUser } }
}
function searchCustomerperAe(payload) {
    return dispatch => {
        dispatch(sqFetching());
        sqServices.searchCustomerperAe(payload)
            .then(
                customerPerAe => {
                    dispatch(success(customerPerAe));
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(customerPerAe) { return { type: sqConstants.SQ_AGING_CUSTOMER_PER_AE, customerPerAe } }
}
function agingReportAe(payload) {
    return dispatch => {
        dispatch(sqFetching());
        sqServices.agingReportAe(payload)
            .then(
                AgingData => {
                    dispatch(success(AgingData));
                    dispatch(sqFetched());
                },
                error => {
                    dispatch(sqFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(AgingData) { return { type: sqConstants.SQ_AGING_DATA, AgingData } }
}